<template>
  <div class="cyber-card p-6 cursor-pointer" :class="{selected: modelValue === id}" @click="$emit('update:modelValue', id)">
    <div class="flex items-center space-x-3">
      <Radio
        :id="id"
        :model-value="modelValue"
        :input-value="id"
        @update:modelValue="$emit('update:modelValue', $event)"
      />

      <div class="flex items-center space-x-4 flex-1">
        <div class="w-12 h-12 rounded-lg flex items-center justify-center" :class="[`bg-${variant}-600`]">
          <slot name="icon" />
        </div>

        <div class="flex-1">
          <h4 class="font-semibold">{{ title }}</h4>
          <p class="text-sm text-gray-600 mt-1">{{ subtitle }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioCard',
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    title: String,
    subtitle: String,
    modelValue: {
      type: [String, Number],
      required: true
    },
    variant: {
      type: String,
      default: 'gray', // e.g. 'gray', 'blue', 'yellow', 'red', etc.
    },
  }
};
</script>
